var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 5.5,
    stroke: "white",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 6C10.0294 6 6 10.0294 6 15C6 19.5453 9.36951 23.3037 13.7469 23.9135V17.0266H11.4V14.3087H13.7469V12.3057C13.7469 9.98576 15.1632 8.71787 17.2404 8.71787C18.2318 8.71787 19.0883 8.79205 19.3378 8.82577V11.2536H17.9013C16.7683 11.2536 16.5525 11.7864 16.5525 12.5755V14.3087H19.2434L18.8927 17.0266H16.5525V23.8666C20.7832 23.131 24 19.4411 24 15C24 10.0294 19.9706 6 15 6ZM15.0103 24H14.9897C14.9932 24 14.9966 24 15 24C15.0034 24 15.0068 24 15.0103 24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon_facebook.6e0314cdaa84eecf0e573aec66ecf959.svg";
export { ForwardRef as ReactComponent };